export const SelectArrowIcon = (props: { rotate?: number }) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ transform: `rotate(${props.rotate || 0}deg)` }}
    >
      <path
        d='M9.3554 4.10493C9.30892 4.05807 9.25361 4.02087 9.19269 3.99548C9.13176 3.9701 9.0664 3.95703 9.0004 3.95703C8.93439 3.95703 8.86904 3.9701 8.80811 3.99548C8.74718 4.02087 8.69188 4.05807 8.6454 4.10493L6.3554 6.39493C6.30892 6.44179 6.25361 6.47899 6.19269 6.50437C6.13176 6.52976 6.0664 6.54282 6.0004 6.54282C5.93439 6.54282 5.86904 6.52976 5.80811 6.50437C5.74718 6.47899 5.69188 6.44179 5.6454 6.39493L3.3554 4.10493C3.30891 4.05807 3.25361 4.02087 3.19268 3.99548C3.13176 3.9701 3.0664 3.95703 3.0004 3.95703C2.93439 3.95703 2.86904 3.9701 2.80811 3.99548C2.74718 4.02087 2.69188 4.05807 2.6454 4.10493C2.55227 4.19861 2.5 4.32534 2.5 4.45743C2.5 4.58952 2.55227 4.71625 2.6454 4.80993L4.9404 7.10492C5.22165 7.38582 5.6029 7.5436 6.0004 7.5436C6.3979 7.5436 6.77915 7.38582 7.0604 7.10492L9.3554 4.80993C9.44852 4.71625 9.50079 4.58952 9.50079 4.45743C9.50079 4.32534 9.44852 4.19861 9.3554 4.10493Z'
        fill='currentColor'
      />
    </svg>
  );
};
